// /api/applications/stuck — Session 7 PR2.

import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface StuckSimilarToProgressed {
  role: string;
  company_id: string;
  similarity: number;
}

export interface StuckApplication {
  application_id: string;
  url: string;
  role: string;
  status: "applied";
  company_id: string | null;
  company_name: string;
  updated_at: number;
  age_days: number;
  similar_to_progressed: StuckSimilarToProgressed | null;
}

export interface StuckResponse {
  stuck: StuckApplication[];
  count: number;
}

export function useStuckApplications() {
  return useQuery({
    queryKey: ["stuck"],
    queryFn: () => api<StuckResponse>("/api/applications/stuck"),
    staleTime: 60_000,
  });
}
